import { h, markRaw, render } from "vue";
import ModuleSandbox from "../components/ModuleSandbox.vue";
import ColorPickerAbsolute from "../components/ColorPickerAbsolute.vue";
import unwrap from "../composables/unwrap.js";
import { reactive, ref } from "#imports";
export class Sandbox {
  id = "nuxt-color-picker:sandbox";
  component = ref();
  boxSize = reactive({ width: 0, height: 0 });
  constructor() {
    this._initSandbox();
  }
  _initSandbox() {
    if (import.meta.client) {
      const nuxtElement = document.getElementById("__nuxt");
      const sandboxElement = document.getElementById(this.id);
      if (nuxtElement && !sandboxElement) {
        const container = document.createElement("div");
        nuxtElement.insertAdjacentElement("afterend", container);
        render(h(ModuleSandbox, { sandbox: this }), container);
        container.replaceWith(...container.childNodes);
      }
    }
  }
  getId() {
    return this.id;
  }
  getComponent() {
    return this.component;
  }
  getBoxSize() {
    return this.boxSize;
  }
  setBoxSize(event) {
    this.boxSize.width = event.width;
    this.boxSize.height = event.height;
  }
  openComponent(position, props, emits) {
    unwrap.set(this, "component", {
      id: "color-picker",
      component: markRaw(ColorPickerAbsolute),
      props: {
        ...props,
        position,
        sandboxSize: this.boxSize
      },
      emits: {
        ...emits,
        close: () => {
          emits.close?.();
          this.closeComponent();
        }
      }
    });
  }
  closeComponent() {
    unwrap.set(this, "component", void 0);
  }
}
